/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'confluence.error.panel.refresh.app': 'アプリを更新',
  'confluence.error.panel.reload.page': 'ページを更新',
  'confluence.icon.label': 'アイコン',
  'confluence.modal.dialog.close.modal.button': 'キャンセル',
  'confluence.select.required.field.message': 'このフィールドは必須です。',
  'confluence.text.area.required.field.message': 'このフィールドは必須です。',
  'confluence.textfield.validator.email': '有効なメール アドレスをご入力ください。',
  'confluence.textfield.validator.number': '有効な数字をご入力ください',
  'confluence.textfield.validator.required.field.message': 'このフィールドは必須です。',
  'confluence.textfield.validator.telephone': '有効な電話番号をご入力ください。',
  'confluence.threeLOPrompt.modal.access.required.title': 'アクセス権が必要です。',
  'confluence.threeLOPrompt.modal.error.title': 'エラー',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    '同意 URL は見つかりませんでした。ページを更新してもう一度お試しください。',
  'confluence.threeLOPrompt.no.authURL.error-message':
    '同意 URL は見つかりませんでした。ページを更新してもう一度お試しください。',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'アクセスを許可',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'アクセスを設定',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': '認証に失敗しました。',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    '{appString} を表示するには、アプリがお客様に代わってアトラシアン製品にアクセスできるようにする必要があります。',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} では、アカウントへの追加のアクセス権が必要です。',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': '外部認証の警告',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'このアプリ',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'このアプリ',
  'confluence.user.group.unknown.user.message': '不明なユーザー',
  'confluence.user.picker.empty.field.error.message': 'このフィールドは必須です。',
  'confluence.user.unknown.user.message': '不明なユーザー',
  'forge-ui.form.submit-button.text': '送信',
  'forge.modal.deprecation.message':
    'お使いのアプリ "{appName}" は、カスタム フィールドで非推奨となっているモーダル編集機能を使用しています。この機能は段階的に廃止されることになっています。代わりにインライン編集を使用できるように、システム管理者にアプリのアップデートを依頼してください。問題が解決しない場合は、アプリ開発者に連絡してください。',
  'forge.modal.deprecation.title': 'アプリを更新してください',
};
